import _ from 'lodash';
import React, { Component } from 'react';
import { MOBILE_ELEMENT_CONTROLS_ID } from 'crazyEditor/core/constants/editorConstants';
import Radium from 'radium';
import { connect } from 'react-redux';
import styles from './ElementControlsStyles';
import { LayoutControl, EditControl, SizeControl, PositionControl } from './controls/index';
import { getSelectedElements, getPageElement, isMultiSelect } from 'crazyEditor/redux/modules/element/elementSelectors';
import { getElementDefinitionProps, isFontSelectable, isHyperlinkEnabled, getElementIcon, getElementName } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { isBackgroundElement, isPageElement, isStaticElement } from 'crazyEditor/core/elements/utils/elementStaticUtils';
const classes = require('shared/styles/common.scss');

@connect(
  state => ({
    isMultiSelect: isMultiSelect(state),
    selectedElementIds: state.stage.selectedElementIds,
    selectedElements: getSelectedElements(state),
    stageLayoutTop: state.stage.layout.top,
    pageElement: getPageElement(state),
    viewMode: state.editor.viewMode
  })
)
@Radium
export default class MobileElementControls extends Component {
  render() {
    const { selectedElementIds, stageLayoutTop, isMultiSelect, selectedElements, pageElement, viewMode } = this.props;
    let elementDefinitionProps = null;
    if (selectedElements.length) {
      elementDefinitionProps = getElementDefinitionProps(selectedElements[0], true);
    }
    const _isBackgroundElement = isBackgroundElement(selectedElements[0].id);
    const _isPageElement = isPageElement(selectedElements[0].id);
    const _isStaticElement = isStaticElement(selectedElements[0].id);
    return (
      <div id={MOBILE_ELEMENT_CONTROLS_ID} className={classes.noSelect} style={[styles.wrapper, {top: stageLayoutTop}]}>
        <div style={styles.container}>
          {!_isPageElement &&
            [
              <EditControl key="editControl" selectedElementIds={selectedElementIds} isMultiSelect={isMultiSelect}/>,
              <LayoutControl key="layoutControl" selectedElementIds={selectedElementIds}
                             selectedElements={selectedElements}
                             isMultiSelect={isMultiSelect}
                             viewMode={viewMode}/>
            ]
          }
          {!_isBackgroundElement && !isMultiSelect &&
          <SizeControl
            selectedElementIds={selectedElementIds}
            elementDefinitionProps={elementDefinitionProps}
            isPageElement={_isPageElement}
          />
          }
          {!_isStaticElement && !isMultiSelect &&
          <PositionControl
            selectedElementIds={selectedElementIds}
            elementDefinitionProps={elementDefinitionProps}
            pageElement={pageElement}/>
          }
        </div>
      </div>
    );
  }
}
